import { useState } from "react";
import { TENANT_DOMAIN } from "../../utils/domain";
import { ERROR_MESSAGES } from "../../constant/constant";
import { useAxios } from "../../utils/useAxios";

/**
 * @typedef {Object} CancelInvoiceResponse
 * @property {boolean} success
 * @property {string} message
 * @property {any} data
 * @property {any} meta
 */

/**
 * Hook to cancel an addon invoice request
 */
export const useCancleAddonInvoiceRequest = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const { axiosInstance } = useAxios();

    /**
     * Cancel an addon invoice
     * @param {string|number} invoiceId 
     * @returns {Promise<CancelInvoiceResponse>}
     */
    const cancleInvoice = async (invoiceId) => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await axiosInstance.post(
                `${TENANT_DOMAIN}/billing/payment/addon/invoice/${invoiceId}/cancel`,
                {}
            );

            setSuccess(true);
            return response.data;

        } catch (err) {
            setSuccess(false);
            const responseData = err?.response?.data;

            if (responseData) {
                setError(responseData.message || ERROR_MESSAGES.UNKNOWN);
                return responseData;
            } else {
                setError(ERROR_MESSAGES.UNKNOWN);
                return {
                    success: false,
                    message: ERROR_MESSAGES.UNKNOWN,
                };
            }
        } finally {
            setLoading(false);
        }
    };

    return { cancleInvoice, loading, error, success };
};
